(function (window) {
  const PC_BREAKPOINT = 769;

  function isMobileView() {
    return window.innerWidth < PC_BREAKPOINT;
  }

  function getVisibleSlideCount(swiper) {
    swiper.update();

    if (!swiper.slides.length) return 1;

    const containerWidth = swiper.width;
    const gap = swiper.params.spaceBetween || 0;
    let used = -gap;
    let visible = 0;

    for (let i = 0; i < swiper.slides.length; i++) {
      used += gap + swiper.slides[i].offsetWidth;
      if (used <= containerWidth + 1) {
        visible += 1;
      } else {
        break;
      }
    }

    return Math.max(1, visible);
  }

  function getPageCount(swiper) {
    const total = swiper.slides.length;
    if (total <= 1) return 1;
    if (isMobileView()) return total;

    const visible = getVisibleSlideCount(swiper);
    return Math.max(1, total - visible + 1);
  }

  function getActivePage(swiper, pageCount) {
    if (pageCount <= 1) return 0;
    if (swiper.isEnd) return pageCount - 1;
    if (isMobileView()) return swiper.activeIndex;

    const visible = getVisibleSlideCount(swiper);
    const maxStart = Math.max(0, swiper.slides.length - visible);
    return Math.min(swiper.activeIndex, maxStart);
  }

  function getSlideIndexForPage(swiper, pageIndex, pageCount) {
    if (isMobileView()) return pageIndex;
    if (pageIndex >= pageCount - 1) return swiper.slides.length - 1;
    return pageIndex;
  }

  function getSegmentClass(progressEl) {
    const first = progressEl.querySelector('button');
    if (!first) return '';

    return (
      [...first.classList].find(
        (className) => className.endsWith('__progress-segment') && className !== 'carousel-progress__segment'
      ) || ''
    );
  }

  function renderSegments(progressEl, pageCount, segmentClass, activePage) {
    const existing = progressEl.querySelectorAll('[data-carousel-page]');

    if (existing.length === pageCount) {
      existing.forEach((segment, index) => {
        segment.classList.toggle('is-active', index === activePage);
        segment.setAttribute('aria-label', `Go to page ${index + 1}`);
      });
      return;
    }

    progressEl.innerHTML = '';

    for (let i = 0; i < pageCount; i++) {
      const segment = document.createElement('button');
      segment.type = 'button';
      segment.className = `carousel-progress__segment ${segmentClass}`.trim();
      segment.dataset.carouselPage = String(i);
      segment.setAttribute('aria-label', `Go to page ${i + 1}`);
      if (i === activePage) segment.classList.add('is-active');
      progressEl.appendChild(segment);
    }
  }

  function createSwiperProgress(swiper, progressEl) {
    if (!progressEl) return null;

    const segmentClass = getSegmentClass(progressEl);
    let resizeTimer = null;

    const sync = () => {
      const pageCount = getPageCount(swiper);
      const activePage = getActivePage(swiper, pageCount);
      progressEl.hidden = pageCount <= 1;
      renderSegments(progressEl, pageCount, segmentClass, activePage);
    };

    const onProgressClick = (event) => {
      const segment = event.target.closest('[data-carousel-page]');
      if (!segment || !progressEl.contains(segment)) return;

      const pageIndex = Number(segment.dataset.carouselPage);
      if (Number.isNaN(pageIndex)) return;

      const pageCount = getPageCount(swiper);
      const slideIndex = getSlideIndexForPage(swiper, pageIndex, pageCount);
      swiper.slideTo(slideIndex);
    };

    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 150);
    };

    progressEl.addEventListener('click', onProgressClick);
    window.addEventListener('resize', onResize);
    sync();

    return {
      sync,
      destroy() {
        clearTimeout(resizeTimer);
        progressEl.removeEventListener('click', onProgressClick);
        window.removeEventListener('resize', onResize);
      },
    };
  }

  window.CarouselProgress = {
    createSwiperProgress,
  };
})(window);
